<ng-template #myWorkSidenavActions>
  <br>

  <button mat-button
    color="primary"
    (click)="contractsViewSelected()">
    Contracts
  </button>

  <br>

  <button mat-button
    [disabled]="false"
    color="primary"
    (click)="coiViewSelected()">
    COIs
  </button>

  <br>

  <button mat-button
    [disabled]="false"
    color="primary"
    (click)="baaViewSelected()">
    BAAs
  </button>

  <br>

  <button mat-button
    [disabled]="false"
    color="primary"
    (click)="importantDatesViewSelected()">
    Important Dates
  </button>

  <br>

  <button mat-button
    [disabled]="!provisions"
    color="primary"
    (click)="provisionsViewSelected()">
    Provisions
  </button>

  <br>

  <button mat-button
    color="primary"
    (click)="assessmentsViewSelected()">
    Assessments
  </button>

  <br>

  <button mat-button
    [disabled]="!workflowManagement"
    color="primary"
    (click)="workflowViewSelected()">
    Workflow
  </button>

  <br>

  <button mat-button
    [disabled]="!timesheets"
    color="primary"
    (click)="timesheetsViewSelected()">
    Provider Timesheets
  </button>

  <br>

  <button mat-button
    [disabled]="!timecards"
    color="primary"
    (click)="hcpTimecardsViewSelected()">
    Timecards
  </button>

  <br>

  <mat-divider></mat-divider>

  <br>
  <br>

</ng-template>


<mat-sidenav-content>
  <!-- Build stamp — which build is live. Replaces the old temporary '#' marker. -->
  <div class="deploy-marker" [title]="'Build ' + buildStamp">{{ buildStamp }}</div>

  <mat-grid-list cols="12" rowHeight="40px">
  </mat-grid-list>

  <!-- Dynamic component container -->
  <div #dynamicComponentContainer></div>
</mat-sidenav-content>